export default __webpack_public_path__ + "static/media/Dog on bed.3d6f1e6a.svg";